// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    margin: 0px;\n}\n\nbody, html, .playground_wrapper_27Lh0 {\n\theight: 100%\n}\n\n.playground_playgroundContainer_3CQoG{\n\theight: 90%;\n\twidth: 90%;\n\tmargin: auto;\n}\n\n#playground_fileInput_fFns4 {\n\tdisplay: none;\n}\n\n.playground_playgroundButton_hZeTH {\n\tmargin: 4px;\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "playground_wrapper_27Lh0",
	"playgroundContainer": "playground_playgroundContainer_3CQoG",
	"fileInput": "playground_fileInput_fFns4",
	"playgroundButton": "playground_playgroundButton_hZeTH"
};
module.exports = exports;
